import { render, staticRenderFns } from "./LocationPrinters.vue?vue&type=template&id=0faddd78&scoped=true&"
import script from "./LocationPrinters.vue?vue&type=script&lang=js&"
export * from "./LocationPrinters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faddd78",
  null
  
)

export default component.exports